import React from "react";

interface CurrencyDisplayProps {
  amount: number | null | undefined;
  currency: string;
  placeholder?: string;
}

/**
 * A reusable component to format and display monetary values.
 * It handles null or undefined amounts gracefully by showing a placeholder.
 *
 * @param {number | null | undefined} amount - The monetary amount to display.
 * @param {string} currency - The ISO 4217 currency code (e.g., 'USD', 'LBP').
 * @param {string} [placeholder='--'] - The string to display if the amount is not available.
 */
const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({
  amount,
  currency,
  placeholder = "--",
}) => {
  if (amount === null || typeof amount === "undefined") {
    return <span>{placeholder}</span>;
  }

  const formatter = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency,
    currencyDisplay: "code",
  });

  return <span>{formatter.format(amount)}</span>;
};

export default CurrencyDisplay;
